/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ time: NonNullable<unknown> }} Einvoice_Observed_AtInputs */

const vi_einvoice_observed_at = /** @type {(inputs: Einvoice_Observed_AtInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Quan sát gần nhất: ${i?.time}`)
};

/**

* @param {Einvoice_Observed_AtInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_observed_at = /** @type {((inputs: Einvoice_Observed_AtInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Observed_AtInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_observed_at(inputs)
});